
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class StoreService extends CommonService {
  async getStoresReport(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`stores/?${query}`);
  }

  async getStoresReviews(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`stores/reviews/?${query}`);
  }

	async deleteStoresReview(id: string) {
		return await this.delete(`stores/reviews/${id}`)
	}

  async createStore(parmas: { [key: string]: boolean | string }) {
    return await this.post('stores', parmas)
  }

  async createReviewStore(parmas: { [key: string]: boolean | string }) {
    return await this.post('stores/reviews', parmas)
  }
	async updateReviewStore(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`stores/reviews/${id}`, params)
	}

	async getStoresDetails(id: string) {
		return await this.get(`stores/reviews/${id}`)
	}

	async getStoresReviewDetails(id: string) {
		return await this.get(`stores/reviews/${id}`)
	}
}
export const storeService = new StoreService();
